import { type PlaceDetails } from "types/quote-types";
import { type Destination } from ".";

export function isIsraelTrip(places: Array<Destination | PlaceDetails>) {
  for (const place of places) {
    if ("country" in place) {
      if (place.country === "IL") {
        return true;
      }
    } else if (
      place.placeId === "ChIJi8mnMiRJABURuiw1EyBCa2o" ||
      place.terms?.[place.terms.length - 1]?.value.toLowerCase() === "israel"
    ) {
      return true;
    }
  }

  return false;
}
